import { AxiosError } from 'axios';
import { AXIOS_RETRIES_LEFT_HEADER_NAME } from '@vsf-enterprise/sapcc-api';

export const getHeadersWithRetriesLeft = (
  error: AxiosError,
  retriesLeft: number
) => {
  const { headers } = error.config;
  return {
    ...headers,
    [AXIOS_RETRIES_LEFT_HEADER_NAME]: retriesLeft
  };
};
